import { render, staticRenderFns } from "./MainPageInfo.vue?vue&type=template&id=30628509&scoped=true&"
import script from "./MainPageInfo.vue?vue&type=script&lang=js&"
export * from "./MainPageInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30628509",
  null
  
)

export default component.exports